import { createAction, props } from '@ngrx/store';

import { DynamicComponent } from '@priva/components/dynamic';

export const openDialog = createAction('[App] Open dialog', props<{ dialog: DynamicComponent }>());
export const closeDialog = createAction('[App] Close dialog');
